import React, { useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { useSelector } from "react-redux";
import Modal from "./Modal";
import {
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
} from "recharts";
import { SCREEN_WIDTH } from "../../Utils/Dimensions";
import { minBy, maxBy, isEmpty } from "lodash";
import { Loader } from "../Shared";
import moment from "moment-jalaali";

const availableChart = ["GOLD", "IRG17", "IRCOLD", "IRCNEW", "IRC2", "IRC4"];

const TableItemX1 = (props) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [chartData, setchartData] = useState([]);
  const [domain, setdomain] = useState([]);
  const { type, status, title, value } = props;
  const isFaNum = useSelector(
    (state) => state.persistedParams.isFaNum
  )
  const token = useSelector(state => state.auth.token)
  function showChart() {
    if (!availableChart.includes(type)) return;
    setVisibleModal(true);
    const url = `/mobile/chart?type=${type}&time=daily`;
    ApiCall("get", url, {}, "getChart data", token, (res) => {
      if (isEmpty(res.data.daily)) return;
      const arr = res.data.daily?.split("|");
      let data = [];
      arr.forEach((e) => {
        const xy = e.split("-");
        const obj = { x: xy[0], y: xy[1] };
        data.push(obj);
      });
      const minY = minBy(data, "y").y;
      const maxY = maxBy(data, "y").y;
      const yDomain = [minY, maxY];
      setdomain(yDomain);
      setchartData(data);
    });
  }
  function onClose() {
    setVisibleModal(false);
  }
  function calcChartWidth() {
    const length = chartData?.length || 12;
    return length * 3 < SCREEN_WIDTH ? SCREEN_WIDTH : length * 3;
  }

  return (
    <>
      <div
        className={`table_item_x1  _${status}`}
      // onClick={() => showChart()}
      >
        <span className="_title">{title}</span>
        <div className="_value">
          <span className={ isFaNum ? "_label_fa" : "_label_en"}>{value}</span>
          {!!status && (
            <i
              className={
                status === "up"
                  ? "_icon ion-md-arrow-up"
                  : "_icon ion-md-arrow-down"
              }
            ></i>
          )}
        </div>
      </div>
      <Modal
        direction="_bottom"
        isOpen={visibleModal}
        closeModal={onClose}
        className="modalPriceDate"
      >
        <div className="_head">
          <h5 className="_title">{`نمودار قیمت روزانه - ${title}`}</h5>
        </div>
        {isEmpty(chartData) && (
          <Loader
            className="_loading"
            name="GridLoader"
            size={15}
            color="#f6c244"
          />
        )}
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <LineChart
            width={calcChartWidth()}
            height={SCREEN_WIDTH}
            data={chartData}
          >
            <XAxis
              padding={{ left: 0 }}
              dataKey="x"
              fontFamily={"Roboto, sans-serif"}
              fontSize="10px"
            // tickFormatter={customTick}
            // interval={11}
            />
            <YAxis
              dataKey="y"
              domain={domain}
              tickMargin={50}
              fontFamily={"Roboto, sans-serif"}
              fontSize="14px"
            />
            <CartesianGrid stroke="#333333" strokeDasharray="3 3" />
            <Line
              type="monotone"
              dataKey="y"
              stroke="#F6C244"
              dot={{ r: 0, fill: "black" }}
            />
          </LineChart>
          <div className="_modalFooter">
            <div className="_row">
              <h5 className="_text">{domain[0]}</h5>
              <h5 className="_text">{`${type}`}</h5>
            </div>
            <div className="_row">
              <h5 className="_text">{domain[1]}</h5>
              <h5 className="_text">{moment().format("jYY-jMM-jDD")}</h5>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TableItemX1;
